// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1TJff","label":"Labeled_label__1pnKs","divider":"Labeled_divider__1W3Ni"};